import React from "react";
import { observer, useLocalStore } from "mobx-react";
import { Grid } from "@mui/material";
import { EOCAsyncSelect } from "../input/EOCAsyncSelect";
import apiCall from "../../scripts/apiCall";
import { useMsal } from "@azure/msal-react";

export default observer(
  ({
    title,
    value,
    required,
    updatefunc,
    multi = false,
    isCreatable = false,
    a,
  }) => {
    const { instance, accounts } = useMsal();
    const getData = (input) =>
      new Promise((resolve) => {
        let fetchOptions = {
          method: "POST",
          credentials: "same-origin",
          body: JSON.stringify({
            proj: "Z_GW_PROSPECT_SRV",
            funct: "PaymentTermSet",
            //parameters: `$format=json`,
            parameters: `$top=20&$filter=PaymentTermID eq '${input.toUpperCase()}*'&$format=json`,
          }),
        };
        var sys = window.localStorage.getItem("QUOTEsys");
        let url = `SAPOData${sys}`;
        return apiCall(
          url,
          fetchOptions,
          (json) => {
            resolve(
              json.map((result) => ({
                Id: result.PaymentTermID,
                Name: result.PaymentTermDescription,
                value: result.PaymentTermID,
                label:
                  result.PaymentTermID +
                  " (" +
                  result.PaymentTermDescription +
                  ")",
              }))
            );
          },
          instance,
          accounts
        );
      });

    const lstore = useLocalStore(() => ({
      onChange(newVal, actionMeta) {
        if (newVal !== null) {
          if (multi) {
            if (isCreatable && actionMeta.action === "create-option")
              newVal.forEach((element) => {
                if (element.__isNew__) {
                  element.Name = element.label;
                  element.Id = "0";
                }
              });
            updatefunc(newVal);
          } else {
            if (newVal.__isNew__) {
              newVal.Name = newVal.label;
              newVal.Id = "0";
            }
            updatefunc(newVal);
          }
        } else {
          updatefunc(null);
        }
      },
    }));

    return (
      <Grid container spacing={0} direction="column">
        <Grid item xs>
          <label>
            {title}
            {required && " *"}
          </label>
        </Grid>
        <Grid item xs>
          <EOCAsyncSelect
            cy={title}
            isMulti={multi}
            loadOptions={getData}
            value={value}
            updateF={lstore.onChange}
            clearAble={isCreatable}
            isCreatable={isCreatable}
            defaultOptions
          />
        </Grid>
      </Grid>
    );
  }
);
